import axios from "axios";
import { Navigate } from "react-router-dom";

export const load_subcategories_list = async (data) => {
  if (localStorage.getItem('access')) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${localStorage.getItem('access')}`,
        'Accept': 'application/json',
      },
    };
    if (data) {
      config.params = {
        ...data
      }
    }

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/management_api/subcategorias/`, config);

      return response.data;
    } catch (err) {
      console.log(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
}
export const load_subcategory_data_from_id = async (id) => {
  if (localStorage.getItem('access')) {

    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${localStorage.getItem('access')}`,
        'Accept': 'application/json'
      }
    };

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/management_api/subcategoria/${id}`, config);
      return response.data;
    } catch (err) {
      console.log(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};
export const delete_subcategory_from_id = async (id) => {
  if (localStorage.getItem('access')) {

    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${localStorage.getItem('access')}`,
        'Accept': 'application/json'
      }
    };

    try {
      const response = await axios.delete(`${process.env.REACT_APP_API_URL}/management_api/subcategoria/${id}`, config);
      return response.data;
    } catch (err) {
      console.log(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};
export const upload_subcategories = async (data) => {
  if (localStorage.getItem('access')) {

    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${localStorage.getItem('access')}`,
        'Accept': 'application/json'
      }
    };
    const body = JSON.stringify({ ...data });

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/management_api/subcategorias/`, body, config);
      return response.data;
    } catch (err) {
      console.log(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};



export const load_actives_list = async (data) => {
  if (localStorage.getItem('access')) {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${localStorage.getItem('access')}`,
        'Accept': 'application/json',
      },
    };
    if (data) {
      config.params = {
        ...data
      }
    }

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/management_api/activos/`, config);

      return response.data;
    } catch (err) {
      console.log(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
}

export const load_active_data_from_id = async (id) => {
  if (localStorage.getItem('access')) {

    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${localStorage.getItem('access')}`,
        'Accept': 'application/json'
      }
    };

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/management_api/activo/${id}`, config);
      return response.data;
    } catch (err) {
      console.log(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};
export const delete_active_from_id = async (id) => {
  if (localStorage.getItem('access')) {

    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${localStorage.getItem('access')}`,
        'Accept': 'application/json'
      }
    };

    try {
      const response = await axios.delete(`${process.env.REACT_APP_API_URL}/management_api/activo/${id}`, config);
      return response.data;
    } catch (err) {
      console.log(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};
export const edit_active_from_id = async (id, data) => {
  if (localStorage.getItem('access')) {

    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${localStorage.getItem('access')}`,
        'Accept': 'application/json'
      }
    };
    const body = JSON.stringify({ ...data });

    try {
      const response = await axios.put(`${process.env.REACT_APP_API_URL}/management_api/activo/${id}`, body, config);
      return response.data;
    } catch (err) {
      console.log(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};

export const upload_active = async (data) => {
  if (localStorage.getItem('access')) {

    const config = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${localStorage.getItem('access')}`,
        'Accept': 'application/json'
      }
    };
    const body = JSON.stringify({ ...data });

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/management_api/activos/`, body, config);
      return response.data;
    } catch (err) {
      console.log(err);
    }
  } else {
    return <Navigate to="/login" replace />;
  }
};

